import { create } from 'zustand';
import { persist } from 'zustand/middleware';

// Configuración de propinas por terminal.
// Un negocio de retail las deja apagadas; una cafetería las enciende.
// Los porcentajes son los botones rápidos que ve el cajero al cobrar.
export const useTipsStore = create(
  persist(
    (set) => ({
      enabled:  false,
      presets:  [10, 15, 20],   // porcentajes sugeridos

      setEnabled: (enabled) => set({ enabled }),
      setPresets: (presets) =>
        set({
          presets: presets
            .map(Number)
            .filter((n) => Number.isFinite(n) && n > 0 && n <= 100)
            .slice(0, 4),
        }),
    }),
    { name: 'pos_tips' }
  )
);
